import React, { useState } from "react";
import NumberField from "./NumberField";
import FormHeader from "./FormHeader";
import OTPField from "./OTPField";
import SendOTPButton from "./SendOTPButton";
import SignUpGoogleBtn from "./SignUpGoogleBtn";
import SignUpField from "./SignUpField";
import { toast } from "sonner";
import {
  LOGIN_FORM_TITLE,
  LOGIN_FORM_SUB_TITLE,
  LOGIN_FORM_RESEND_OTP_LIMIT,
} from "../../constants/text_constants";
import SignInButton from "./SignInButton";
import SignUpTermsCondition from "./SignUpTermsCondition";
import ResendOTPButton from "./ResendOTPButton";
import BG_IMAGE from "../../assets/BG_IMAGE.jpg";

const LoginPageRightForm = () => {
  const [mobileNo, setMobileNo] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [tnc, setTnc] = useState(true);
  const [otpToast, setOtpToast] = useState(false);
  const [resendOtpBtnClick, setResendOtpBtnClick] = useState(0);
  const [hashedOTP, setHashedOTP] = useState(null);

  if (showOtp && otpToast) {
    toast(`An OTP has been sent to ${mobileNo}`);
    setOtpToast(false);
  }

  return (
    <div
      style={{
        fontFamily: "DM Sans",
        fontStyle: "normal",
        lineHeight: "normal",
      }}
      className="mt-[3rem] md:mt-[2rem] lg:px-0 px-[1rem]"
    >
      <FormHeader title={LOGIN_FORM_TITLE} subtitle={LOGIN_FORM_SUB_TITLE} />
      <NumberField
        setMobileNo={setMobileNo}
        mobileNo={mobileNo}
        showEdit={mobileNo.length === 10}
        setShowOtp={setShowOtp}
        setOtp={setOtp}
        showOtp={showOtp}
      />
      {mobileNo.length === 10 && showOtp && (
        <div className="lg:flex lg:flex-row lg:items-center lg:justify-between flex flex-col items-center lg:mt-0 -mt-6">
          <div>
            <OTPField otp={otp} setOtp={setOtp} />
          </div>
          {resendOtpBtnClick < LOGIN_FORM_RESEND_OTP_LIMIT && (
            <div>
              <ResendOTPButton
                resendOtpBtnClick={resendOtpBtnClick}
                setResendOtpBtnClick={setResendOtpBtnClick}
                setHashedOTP={setHashedOTP}
                mobileNo={mobileNo}
              />
            </div>
          )}
        </div>
      )}
      {/* Terms and Condition */}
      {mobileNo.length === 10 && showOtp && (
        <SignUpTermsCondition setTnc={setTnc} tnc={tnc} />
      )}
      {(mobileNo.length !== 10 || showOtp === false) && (
        <SendOTPButton
          setShowOtp={setShowOtp}
          mobileNo={mobileNo}
          setOtpToast={setOtpToast}
          setHashedOTP={setHashedOTP}
        />
      )}
      {mobileNo.length === 10 && showOtp && (
        <SignInButton
          otp={otp}
          hashedResponse={hashedOTP}
          tnc={tnc}
          mobileNo={mobileNo}
        />
      )}

      <div className="lg:mt-6 -mt-[1rem] flex items-center justify-between">
        <hr className="flex-grow border-gray-300" />
        <span className="mx-4 text-sm text-gray-500">OR</span>
        <hr className="flex-grow border-gray-300" />
      </div>
      <SignUpGoogleBtn />
      <div
        style={{
          backgroundImage: `url('${BG_IMAGE}')`,
          backgroundSize: "cover",
          backgroundPosition: "bottom right",
        }}
        className = "h-[8rem] w-[15rem] absolute -bottom-1.5 right-0 xs:block hidden"
      ></div>
      {/* <SignUpField /> */}
    </div>
  );
};

export default LoginPageRightForm;
